// Two dates, deliberately separate. `publishedOn` is the launch date of the
// loan-program hubs and must never move: schema.org `datePublished` describes
// when a URL first existed. `reviewedOn` advances every time a licensed
// originator re-reviews the content, and feeds `dateModified`. The visible
// reviewer card was deliberately removed in edc99b3; loan-program-hubs.test.ts
// guards that decision. Sharing one constant made a review silently rewrite
// the launch date.
export const PROGRAM_REVIEW = {
  publishedOn: '2026-08-07',
  reviewedOn: '2026-08-08',
  reviewedLabel: 'August 8, 2026'
} as const;

// Separate publication clock for the comparison URL, which first exists on its
// own launch date rather than the hubs'. It must not inherit a future hub
// review and silently rewrite when this page first existed.
export const FHA_VS_CONVENTIONAL_REVIEW = {
  publishedOn: '2026-08-08',
  reviewedOn: '2026-08-08',
  reviewedLabel: 'August 8, 2026'
} as const;

export type ProgramReview = {
  publishedOn: string;
  reviewedOn: string;
  reviewedLabel: string;
};
